import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=0c227e5d&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=0c227e5d&prod&scoped=true&lang=css"
import style1 from "./ProfileInfo.vue?vue&type=style&index=1&id=0c227e5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c227e5d",
  null
  
)

export default component.exports